var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11719 15.4092C9.86719 16.1202 10.8899 16.5488 12.0003 16.5488C13.1107 16.5488 14.1334 16.1202 14.8834 15.4092",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3701 12.3799C15.5799 12.3799 15.75 12.2098 15.75 12C15.75 11.7902 15.5799 11.6201 15.3701 11.6201C15.1603 11.6201 14.9902 11.7902 14.9902 12C14.9902 12.2098 15.1603 12.3799 15.3701 12.3799Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62987 12.3799C8.83967 12.3799 9.00974 12.2098 9.00974 12C9.00974 11.7902 8.83967 11.6201 8.62987 11.6201C8.42007 11.6201 8.25 11.7902 8.25 12C8.25 12.2098 8.42007 12.3799 8.62987 12.3799Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3633 6.55469C10.3633 7.46053 11.0938 8.19105 11.9996 8.19105C12.9055 8.19105 13.636 7.46053 13.636 6.55469",
    stroke: "#C18344",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 3C11.9996 3 10.3633 4.94805 10.3633 6.5552",
    stroke: "#C18344",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKid);
export default __webpack_public_path__ + "static/media/kid.24f6e1d88041386f8f5486c18b421745.svg";
export { ForwardRef as ReactComponent };